import React from 'react'
import { BrowserRouter as Router } from "react-router-dom"
import Routing from './routes';
import './assets/vendors/bootstrap/css/bootstrap.css'
import './assets/vendors/fontawesome/css/all.min.css'
import './assets/vendors/animate/animate.min.css'
import './assets/vendors/youtube-popup/youtube-popup.css'
import './assets/vendors/icomoon/style.css'
import './assets/css/style.css'
import './assets/css/responsive.css'

function App() {
  return (
    <Router basename='/zoso'>
      <Routing />
    </Router>
  );
}

export default App;

